import ProductInformationForm from './ProductInformationForm';
import { userActions, userDataSel } from 'src/store/modules/user';
import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';

interface IStateFromProps {
  isLoggedIn: boolean;
}

const mapStateToProps = (state: any) => {
  return {
    userData: userDataSel(state),
    isLoggedIn: state.signin.success
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onLoad: () => {
    dispatch(userActions.getUserDetails());
  }
});

export default connect(mapStateToProps)(withI18n()(ProductInformationForm));
interface IDispatchFromProps {
  onLoad(): void;
}
